// extracted by mini-css-extract-plugin
module.exports = {"input":"ComposeInput__input__U2DxK"};